var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 114,
    viewBox: "0 0 110 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.569824,
    width: 110,
    height: 113,
    rx: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7813 70.881L70.6959 36.3456C70.8284 35.572 70.0587 34.9543 69.3321 35.251L31.9507 50.5189C31.1702 50.8377 31.1102 51.9199 31.8507 52.3229L42.6176 58.1835C42.8707 58.3213 43.0521 58.5616 43.1152 58.8428L45.2625 68.4058C45.4259 69.1333 46.2993 69.4326 46.8745 68.9582L52.7961 64.0745C53.1638 63.7712 53.6946 63.7697 54.0641 64.0708L63.1639 71.4873C63.7574 71.971 64.6521 71.6356 64.7813 70.881Z",
    stroke: "#D0EE11",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2235 42.5438L40.8306 55.864C40.6362 55.985 40.5489 56.2227 40.6187 56.4408L44.3888 68.2222C44.455 68.4293 44.6475 68.5698 44.865 68.5698H45.5232C45.7901 68.5698 46.01 68.3602 46.0227 68.0936L46.4901 58.2778C46.4964 58.1447 46.5556 58.0196 46.6546 57.9304L62.8228 43.3395C63.2757 42.9308 62.7414 42.2214 62.2235 42.5438Z",
    fill: "#D0EE11"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.756c8b09d63b5d630367ca8659f8d942.svg";
export { ForwardRef as ReactComponent };